"use strict";
/**
 * @file Created on 02/27/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var ResourceLockResultDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ResourceLockResultDTOConverter, _DataObjectConverter_);

  function ResourceLockResultDTOConverter() {
    _classCallCheck(this, ResourceLockResultDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockResultDTOConverter).apply(this, arguments));
  }

  return ResourceLockResultDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ResourceLockResultDTOConverter = ResourceLockResultDTOConverter;